@if (recommendedService && recommendedService.length > 0) {
  <div class="px-3 px-md-5 py-5">
    <div class="text-center py-2">
      <h3>{{'homepage.direct-channel.recommended-service.title' | translate}}</h3>
    </div>
    <div class="container-fluid pt-4" (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
      <div class="row row-cols-1 row-cols-md-2 mx-sm-0 row-cols-lg-5 ">
        @for (item of recommendedService; track item; let i = $index) {
          <div>
            <div class="col row-md-12 hover-card" (click)="goToService(item)">
              @if (item.image === null || item.image === undefined) {
                <div class="squareImg">
                  <img class="img img-responsive full-width" src="\assets\images\bandi.png" />
                </div>
              }
              @if (item.image !== null && item.image !== undefined) {
                <div class="squareImg">
                  <img class="img img-responsive full-width" src="{{ item.image }}" />
                </div>
              }
              @if (item.title.length <= 100) {
                <h4 class="title pt-4">
                  {{ item.title }}
                </h4>
              }
              @if (item.title.length > 100) {
                <h4 class="title pt-4" [ngbTooltip]="item.title">
                  {{ (item.title | slice:0:100) + '...'}}
                </h4>
              }
            </div>
          </div>
        }
      </div>
      <!-- SLIDER PAGINATOR -->
      @if (totalPage.length > 1) {
        <div class="row mt-3 py-2 mx-0">
          <!-- DOT -->
          <div class="col-12 col-sm-9 full-width-center position-relative">
            <div class="slick-dots ">
              <div class="row justify-content-center h-100">
                @for (page of totalPage; track page; let i = $index) {
                  <div class="w-fit-content">
                    <button type="button" (click)="changePage(i)" [ngClass]="currentPage == i ? 'active-slick' : ''"></button>
                  </div>
                }
              </div>
            </div>
          </div>
          <!-- ARROW -->
          <div class="col-12 col-sm-3 mt-5 mt-sm-0">
            <div class="row justify-content-end">
              <button class="fill-orange btn-white page-button" (click)="changePage(currentPage-1)"
                [disabled]='currentPage == 0'>
                <fa-icon [icon]="faAngleLeft"></fa-icon>
              </button>
              <button class="fill-orange btn-white page-button" (click)="changePage(currentPage+1)"
                [disabled]="currentPage == totalPage.length-1">
                <fa-icon [icon]="faAngleRight"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
